import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';
import HeroSection from '../components/HeroSection';
import ProductCard from '../components/ProductCard';

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [menTop, setMenTop] = useState([]);
  const [womenTop, setWomenTop] = useState([]);
  const [categories, setCategories] = useState([]);
  const [settings, setSettings] = useState(null);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const safe = (p) => p.catch(() => ({ data: { results: [] } }));
    Promise.all([
      safe(api.get('catalog/products/', { params: { is_featured: true } })),
      safe(api.get('catalog/products/', { params: { ordering: '-created_at', page_size: 8 } })),
      safe(api.get('catalog/products/', { params: { gender: 'M', ordering: '-created_at' } })),
      safe(api.get('catalog/products/', { params: { gender: 'W', ordering: '-created_at' } })),
      safe(api.get('catalog/categories/')),
      safe(api.get('settings/')),
    ]).then(([feat, newArr, men, women, cats, sett]) => {
      setFeatured((feat.data.results || feat.data).slice(0, 8));
      setNewArrivals((newArr.data.results || newArr.data).slice(0, 4));
      setMenTop((men.data.results || men.data).slice(0, 4));
      setWomenTop((women.data.results || women.data).slice(0, 4));
      const allCats = [];
      (cats.data.results || cats.data).forEach(c => {
        allCats.push(c);
        (c.children || []).forEach(ch => allCats.push(ch));
      });
      setCategories(allCats.slice(0, 8));
      setSettings(sett.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (email) {
      try {
        await api.post('newsletter/subscribe/', { email });
        toast.success('Subscribed successfully!');
        setEmail('');
      } catch {
        toast.error('Subscription failed');
      }
    }
  };

  const sectionTitle = { fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 400, letterSpacing: 3, textTransform: 'uppercase', textAlign: 'center', marginBottom: 32 };
  const viewAll = { display: 'inline-block', marginTop: 24, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', borderBottom: '1px solid #000', paddingBottom: 2 };

  return (
    <div>
      <HeroSection />

      {/* Top Categories */}
      <section style={{ maxWidth: 1200, margin: '0 auto', padding: '70px 20px 40px' }}>
        <h2 style={sectionTitle}>Shop By Category</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 16, textAlign: 'center' }}>
          {categories.map(c => (
            <Link key={c.id} to={`/shop?category=${c.slug}`} style={{ textDecoration: 'none', color: '#000' }}>
              <div style={{ width: 100, height: 100, borderRadius: '50%', background: '#f5f5f5', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, transition: 'all 0.3s', border: '2px solid transparent' }}
                onMouseOver={e => { e.currentTarget.style.borderColor = '#C9A96E'; e.currentTarget.style.background = '#faf8f4'; }}
                onMouseOut={e => { e.currentTarget.style.borderColor = 'transparent'; e.currentTarget.style.background = '#f5f5f5'; }}>
                {c.name[0]}
              </div>
              <p style={{ fontSize: 12, letterSpacing: 1, textTransform: 'uppercase' }}>{c.name}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* Customer's Favorites / Best Sellers */}
      <section style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 20px' }}>
        <h2 style={sectionTitle}>Customer's Favorites</h2>
        <p style={{ textAlign: 'center', fontSize: 13, color: '#888', marginTop: -20, marginBottom: 28 }}>Shop the Best Selling Styles</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 24 }}>
          {featured.slice(0, 4).map(p => <ProductCard key={p.id} product={p} />)}
        </div>
        <div style={{ textAlign: 'center' }}><Link to="/shop" style={viewAll}>View All</Link></div>
      </section>

      {/* Promo Banner */}
      <section style={{ background: '#1a1a1a', color: '#fff', textAlign: 'center', padding: '50px 20px', margin: '40px 0' }}>
        <p style={{ fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', color: '#C9A96E', marginBottom: 8 }}>Limited Time</p>
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 32, fontWeight: 300, letterSpacing: 2, marginBottom: 12 }}>New Season, New Style</h2>
        <p style={{ fontSize: 14, color: '#aaa', marginBottom: 24 }}>Up to 40% off on selected items</p>
        <Link to="/shop" style={{ padding: '14px 40px', border: '1px solid #C9A96E', color: '#C9A96E', fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', textDecoration: 'none' }}>Shop The Sale</Link>
      </section>

      {/* New Arrivals */}
      <section style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 20px' }}>
        <h2 style={sectionTitle}>New Arrivals</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 24 }}>
          {newArrivals.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
        <div style={{ textAlign: 'center' }}><Link to="/shop?ordering=-created_at" style={viewAll}>View All New</Link></div>
      </section>

      {/* Men & Women Split */}
      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', margin: '40px 0' }}>
        <div style={{ background: '#f5f5f5', padding: '60px 40px', textAlign: 'center' }}>
          <p style={{ fontSize: 11, letterSpacing: 3, color: '#888', textTransform: 'uppercase', marginBottom: 8 }}>For Him</p>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 300, letterSpacing: 2, marginBottom: 20 }}>Men's Collection</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, maxWidth: 500, margin: '0 auto' }}>
            {menTop.slice(0, 2).map(p => <ProductCard key={p.id} product={p} />)}
          </div>
          <div style={{ marginTop: 20 }}><Link to="/men" style={viewAll}>Shop Men</Link></div>
        </div>
        <div style={{ background: '#faf8f4', padding: '60px 40px', textAlign: 'center' }}>
          <p style={{ fontSize: 11, letterSpacing: 3, color: '#888', textTransform: 'uppercase', marginBottom: 8 }}>For Her</p>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 300, letterSpacing: 2, marginBottom: 20 }}>Women's Collection</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, maxWidth: 500, margin: '0 auto' }}>
            {womenTop.slice(0, 2).map(p => <ProductCard key={p.id} product={p} />)}
          </div>
          <div style={{ marginTop: 20 }}><Link to="/women" style={viewAll}>Shop Women</Link></div>
        </div>
      </section>

      {/* Trust Badges */}
      <section style={{ maxWidth: 1200, margin: '0 auto', padding: '50px 20px', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24, textAlign: 'center' }}>
        {[
          { icon: '🚚', title: 'Free Shipping', desc: 'On orders above ₹999' },
          { icon: '↩️', title: 'Easy Returns', desc: '7-day return policy' },
          { icon: '🔒', title: 'Secure Payment', desc: '100% secure checkout' },
          { icon: '💎', title: 'Premium Quality', desc: 'Handpicked fabrics' },
        ].map((b, i) => (
          <div key={i}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>{b.icon}</div>
            <h4 style={{ fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 4 }}>{b.title}</h4>
            <p style={{ fontSize: 12, color: '#888' }}>{b.desc}</p>
          </div>
        ))}
      </section>

      {/* Newsletter Subscribe */}
      <section style={{ background: '#f5f5f5', padding: '60px 20px', textAlign: 'center' }}>
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 300, letterSpacing: 2, marginBottom: 8 }}>Stay In Style</h2>
        <p style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>Subscribe for exclusive offers, new arrivals and style tips</p>
        <form onSubmit={handleSubscribe} style={{ display: 'flex', maxWidth: 460, margin: '0 auto', gap: 0 }}>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email"
            style={{ flex: 1, padding: '14px 20px', border: '1px solid #ddd', borderRight: 'none', fontSize: 13, outline: 'none' }} required />
          <button type="submit" style={{ padding: '14px 32px', background: '#1a1a1a', color: '#C9A96E', border: 'none', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', cursor: 'pointer' }}>Subscribe</button>
        </form>
      </section>

      {/* Bottom Banner */}
      {settings?.banner_text && (
        <section style={{ background: '#1a1a1a', color: '#fff', textAlign: 'center', padding: '30px 20px' }}>
          <p style={{ fontSize: 14, fontWeight: 300, letterSpacing: 1 }}>{settings.banner_text}</p>
        </section>
      )}
    </div>
  );
}
